import { render, staticRenderFns } from "./FormGroupCheckbox.vue?vue&type=template&id=04a16ed2"
import script from "./FormGroupCheckbox.vue?vue&type=script&lang=js"
export * from "./FormGroupCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports